import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ProfileLock from "./pages/ProfileLock";

function App() {
  return (
    <Routes>
      <Route path="/:name" element={<Home />} />
    </Routes>
  );
}

export default App;
